import { useSelector } from "react-redux";

import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";
import { RootState } from "src/redux/reducers";
import { AiFileAnalysis } from "src/types";

export default function useGetProjectContentGuidelinesData() {
  const { projectBasicData } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const contentGuidelinesMetaFieldUuid =
    projectBasicData?.contentGuidelinesMetaFieldUuid || "";

  const value = projectBasicData?.metadata.find(
    (field) =>
      field.type === MetaFieldType.AiFileAnalysis &&
      field.uuid === contentGuidelinesMetaFieldUuid,
  )?.value as AiFileAnalysis | undefined;

  const assets = value?.assets?.[0];
  const contentGuidelinesFileName = assets?.fileName ?? "";
  const contentGuidelinesContent = value?.content ?? "";
  const contentGuidelinesFileData = assets?.wsAssetQuery ?? null;

  return {
    contentGuidelinesFileName,
    contentGuidelinesContent,
    contentGuidelinesFileData,
    contentGuidelinesMetaFieldUuid,
  };
}
